import PropTypes from "prop-types";
import React, { useState, useEffect } from "react";
import { Row, Col, Collapse } from "reactstrap";
import { Link, useNavigate } from "react-router-dom";
import withRouter from "components/Common/withRouter";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";

const Navbar = props => {

  const [dashboard, setdashboard] = useState(false);
  const [ui, setui] = useState(false);
  const [role, setRole] = useState("");
  const navigate = useNavigate();
  useEffect(() => {
    const storedRole = localStorage.getItem("userRole");
    if (storedRole) {
      setRole(storedRole);
    }
  }, []);

  useEffect(() => {
    var matchingMenuItem = null;
    var ul = document.getElementById("navigation");
    var items = ul.getElementsByTagName("a");
    removeActivation(items);
    for (var i = 0; i < items.length; ++i) {
      if (window.location.pathname === items[i].pathname) {
        matchingMenuItem = items[i];
        break;
      }
    }
    if (matchingMenuItem) {
      activateParentDropdown(matchingMenuItem);
    }
  });

  const removeActivation = items => {
    for (var i = 0; i < items.length; ++i) {
      var item = items[i];
      const parent = items[i].parentElement;
      if (item && item.classList.contains("active")) {
        item.classList.remove("active");
      }
      if (parent) {
        if (parent.classList.contains("active")) {
          parent.classList.remove("active");
        }
      }
    }
  };

  function activateParentDropdown(item) {
    item.classList.add("active");
    const parent = item.parentElement;
    if (parent) {
      parent.classList.add("active");
      const parent2 = parent.parentElement;
      parent2.classList.add("active");
      const parent3 = parent2.parentElement;
      if (parent3) {
        parent3.classList.add("active");
        const parent4 = parent3.parentElement;
        if (parent4) {
          parent4.classList.add("active");
          const parent5 = parent4.parentElement;
          if (parent5) {
            parent5.classList.add("active");
            const parent6 = parent5.parentElement;
            if (parent6) {
              parent6.classList.add("active");
            }
          }
        }
      }
    }
    return false;
  }

  const handleDashboardClick = (e) => {
    e.preventDefault();
    const selectedStudent = JSON.parse(localStorage.getItem("selected_student"));

    if (selectedStudent) {
      navigate("/parent-dashboard", { state: { student: selectedStudent } });
    } else {
      navigate("/dashboard");
    }

    setui((prev) => !prev); 
  };

  return (
    <React.Fragment>
      <div className="topnav">
        {/* <div className="container-fluid"> */}
          <nav
            className="navbar navbar-light navbar-expand-lg topnav-menu px-2"
            id="navigation"
          >
            <Collapse
              isOpen={props.leftMenu}
              className="navbar-collapse"
              id="topnav-menu-content"
            >
              <ul className="navbar-nav">
                <li className="nav-item dropdown">
                  <Link
                    className="nav-link dropdown-toggle arrow-none"
                    onClick={handleDashboardClick}
                    // to={`/dashboard`}
                  >
                    <i className="bx bx-home-circle me-2"></i>
                    {props.t("Dashboard")} {props.menuOpen}
                  </Link>
                </li>

                {/* <li className="nav-item dropdown">
                  <Link
                    to="/student"
                    onClick={() => setui(!ui)}
                    className="nav-link dropdown-toggle arrow-none"
                  >
                    <i className="bx bx-tone me-2"></i>
                    {props.t("My Kids")}
                  </Link>
                </li> */}
                {/* <li className="nav-item dropdown">
                  <Link
                    to="/feestructure"
                    onClick={() => setui(!ui)}
                    className="nav-link dropdown-toggle arrow-none"
                  >
                    <i className="bx bx-calendar me-2"></i>
                    {props.t("Payment")}
                  </Link>
                </li> */}
               {/*  <li className="nav-item dropdown">
                  <Link
                    // to="/student"
                    onClick={() => setui(!ui)}
                    className="nav-link dropdown-toggle arrow-none"
                  >
                    <i className="bx bx-calendar me-2"></i>
                    {props.t("Menu 1")}
                  </Link>
                </li>
                <li className="nav-item dropdown">
                  <Link
                    // to="/student"
                    onClick={() => setui(!ui)}
                    className="nav-link dropdown-toggle arrow-none"
                  >
                    <i className="bx bx-calendar me-2"></i>
                    {props.t("Menu 2")}
                  </Link>
                </li>
                <li className="nav-item dropdown">
                  <Link
                    // to="/student"
                    onClick={() => setui(!ui)}
                    className="nav-link dropdown-toggle arrow-none"
                  >
                    <i className="bx bx-calendar me-2"></i>
                    {props.t("Menu 3")}
                  </Link>
                </li> */}
              </ul>
            </Collapse>
          </nav>
        </div>
      {/* </div> */}
    </React.Fragment>
  );
};

Navbar.propTypes = {
  leftMenu: PropTypes.any,
  location: PropTypes.any,
  menuOpen: PropTypes.any,
  t: PropTypes.any,
};

const mapStatetoProps = state => {
  const { leftMenu } = state.Layout;
  return { leftMenu };
};

export default withRouter(
  connect(mapStatetoProps, {})(withTranslation()(Navbar))
);